import { useMutation } from '@apollo/client';
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';
import { CONFIRM_EMAIL, LOGIN } from '@/constants/routes';
import { AuthContext } from '@/context/AuthContext';
import { getToken } from '@/services/jwt';
import PageLoader from '../layout/PageLoader';

const ProtectedRoute = () => {
    const { user, loadingUser } = useContext(AuthContext);
    const token = getToken();

    if (!token) return <Navigate to={LOGIN} replace />
    if (!user?.email && !loadingUser) return <Navigate to={LOGIN} replace />
    if (user?.emailConfirmed === false) return <Navigate to={CONFIRM_EMAIL}/>

    return <Outlet />
}

export default ProtectedRoute;